import Splash from "./splash.jpg";
import Logo from "./logo_screens.png";
import Inventariar from "./inventariar.png";
import Movimentacao from "./movimentacao.png";
import Desinvestimento from "./desinvestimento.png";
import Retooling from "./retooling.png";
import GestaoDeAtivos from "./gestao.png";
import Notificacoes from "./notificacoes.png";
import Dashboard from "./dashboard.png";
import HistoricoAtivo from "./historico_ativo.png";
import HistoricoFornecedor from "./historico_fornecedor.png";
import Ativos from "./lista_ativos.png";
import Sair from "./sair.png";
import Home from "./home.png";
import HomeActive from "./home_active.png";
import LogoPoweredBy from "./logoPoweredBy.png";
import Notifications from "./notifications.png";
import LogoHeader from "./logo_header.png";
import MachineImg from "./machine.png";
import Logoff from "./logoff.png";
import UpdateProvider from "./update_provider.png";
import CafNotFound from "./caf_not_found.png";
import CancelRight from "./cancel_right.png";
import Disinvestment from "./disinvestment.png";
import Duplicated from "./duplicated.png";
import NotIsBase from "./not_is_base.png";
import Third from "./third.png";
import Transfer from "./transfer.png";
import Hamburger from "./hamburger_bottom_right.png";
import PrevPage from "./prev_page.png";
import AddRetooling from "./add_retooling.png";
import SearchRetooling from "./search_retooling.png";
import CancelRetooling from "./cancel_request.png";
import DetCAF from "./detalhes_caf.png";
import ListPNumbers from "./p_n_caf.png";
import AddNewCAF from "./add_caf.png";
import CAM from "./cam.png";
import OP50 from "./OP50.png";
import Union from "./Union.png";
import Camm from "./cam.svg";

export {
  Camm,
  Splash,
  Union,
  OP50,
  CAM,
  DetCAF,
  ListPNumbers,
  AddNewCAF,
  Logo,
  Inventariar,
  Movimentacao,
  Desinvestimento,
  Retooling,
  GestaoDeAtivos,
  Notificacoes,
  Dashboard,
  HistoricoAtivo,
  HistoricoFornecedor,
  Ativos,
  Sair,
  Home,
  HomeActive,
  LogoPoweredBy,
  Notifications,
  LogoHeader,
  MachineImg,
  Logoff,
  UpdateProvider,
  CafNotFound,
  CancelRight,
  Disinvestment,
  Duplicated,
  NotIsBase,
  Third,
  Transfer,
  Hamburger,
  PrevPage,
  AddRetooling,
  SearchRetooling,
  CancelRetooling,
};
